import { useState } from "react";
import { X } from "lucide-react";
import ChatBox from "@/components/ChatBox";
import { WILDER_AVATAR } from "@/lib/api";

export default function WilderWidget() {
  const [open, setOpen] = useState(false);
  return (
    <>
      {open && (
        <div className="fixed bottom-20 sm:bottom-24 right-4 sm:right-6 z-50 w-[calc(100vw-2rem)] max-w-sm shadow-2xl fade-up" data-testid="wilder-widget-panel">
          <div className="flex items-center justify-between bg-[#121212] text-[#F9F6F0] px-4 py-3">
            <span className="font-display text-lg">Wilder <span className="text-[#D4AF37]">· genio folle</span></span>
            <button onClick={() => setOpen(false)} data-testid="wilder-widget-close" aria-label="Chiudi">
              <X size={18} />
            </button>
          </div>
          <ChatBox compact />
        </div>
      )}
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-5 right-4 sm:right-6 z-50"
        data-testid="wilder-widget-button"
        aria-label="Apri chat Wilder"
      >
        <img
          src={WILDER_AVATAR}
          alt="Chat con Wilder"
          className={`wilder-float w-14 h-14 rounded-full object-cover border-2 border-[#D4AF37] shadow-lg ${open ? "" : "wilder-ring"}`}
        />
      </button>
    </>
  );
}
